import { useCallback, useEffect } from 'react';
import { migrationConfigs } from '../constants';
import { usePreferenceStore } from '../store';
import { migrateLocalStorage } from '../utils/migration';
import { usePreferenceBulkMutation, usePreferencesBootstrap } from './queries';

export const usePrefBootstrap = () => {
  const isHydrated = usePreferenceStore((state) => state.isHydrated);
  const isBootstrapped = usePreferenceStore((state) => state.isBootstrapped);

  const bootstrapQuery = usePreferencesBootstrap();
  const bulkMutation = usePreferenceBulkMutation();

  const runMigration = useCallback(async () => {
    if (!isHydrated) return;
    const currentPrefs = usePreferenceStore.getState().prefs;
    const needsMigration = migrationConfigs.some(
      (config) => !currentPrefs[config.prefId] && localStorage.getItem(config.localKey)
    );

    if (needsMigration) {
      await migrateLocalStorage(migrationConfigs, bulkMutation);
    }
  }, [isHydrated]);

  useEffect(() => {
    runMigration();
  }, [runMigration]);

  return {
    isHydrated,
    isBootstrapped,
    isLoading: bootstrapQuery.isLoading,
    error: bootstrapQuery.error,
  };
};
